import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.resultsCount': {
    paddingTop: 'var(--abyss-space-xs)',
  },
});
